import { createFileRoute } from "@tanstack/react-router";

import { DeFiPage } from "../../features/defi/pages/defi-page";
import { prefetchProtocolData } from "../../shared/utils/protocol-data";

export const Route = createFileRoute("/_layout/defi")({
  loader: () => {
    // Prefetch protocol metadata used by DeFi components (fire and forget)
    prefetchProtocolData().catch(console.warn);
    return null; // resolves immediately; route can render
  },
  component: DeFiPage,
});
